import React from 'react'
import { Box, Typography, Paper } from '@mui/material'

import Students from 'assets/report/HL_Students.svg'
import Teachers from 'assets/report/HL_Teachers.svg'
import Practice from 'assets/report/HL_Practice.svg'
import Operations from 'assets/report/HL_Operations.svg'
import Certificated from 'assets/report/HL_Certificated.svg'

interface HighlightStatBoxProps {
  number: string
  stat: string
  iconBg: string
}

interface HighlightIconsInterface {
  [key: string]: string
}

const HighlightIcons: HighlightIconsInterface = {
  'Active Students': Students,
  'Active Teachers': Teachers,
  'Operations Assigned': Operations,
  'Student Practice Days': Practice,
  'Certificated Students': Certificated,
}

const getIconBgColor = (iconBg: string): string => {
  const colorMap: { [key: string]: string } = {
    $lightTeal: '#E0F7FA',
    $lightOrange: '#FFF3E0',
  }
  return colorMap[iconBg] || iconBg
}

function HighlightStatBox({ number, stat, iconBg }: HighlightStatBoxProps) {
  return (
    <Paper
      elevation={4}
      sx={{
        height: '100%',
        p: 3,
        display: 'flex',
        flexDirection: 'column',
        textAlign: 'center',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <Box
          sx={{
            backgroundColor: getIconBgColor(iconBg),
            borderRadius: '50%',
            width: '2.25rem',
            height: '2.25rem',
            mr: 3,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <Box
            component='img'
            src={HighlightIcons[stat]}
            alt={stat}
            sx={{ width: '1.5rem', height: '1.5rem' }}
          />
        </Box>
        <Typography sx={{ fontSize: '36px', fontWeight: 600 }}>
          {number}
        </Typography>
      </Box>
      <Typography
        sx={{
          mt: 3,
          color: 'text.secondary',
          flexGrow: 1,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        {stat}
      </Typography>
    </Paper>
  )
}

export default HighlightStatBox
